import { useEffect, useState } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

const CONTENT_URL = import.meta.env.VITE_TEAMS_CONTENT_URL
  ?? 'https://wonderful-ocean-013641610.7.azurestaticapps.net';

export function TeamsConfigPage() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    microsoftTeams.app.initialize().then(() => {
      microsoftTeams.pages.config.setValidityState(true);
      microsoftTeams.pages.config.registerOnSaveHandler(async (saveEvent) => {
        try {
          await microsoftTeams.pages.config.setConfig({
            entityId: 'pmp-meeting',
            contentUrl: CONTENT_URL,
            suggestedDisplayName: 'Meeting Pulse',
          });
          saveEvent.notifySuccess();
        } catch {
          saveEvent.notifyFailure('No se pudo guardar la configuración.');
        }
      });
      setReady(true);
    }).catch(() => setReady(true));
  }, []);

  return (
    <div style={{ fontFamily: 'sans-serif', padding: '24px', color: '#fff', background: '#1e1e2e', minHeight: '100vh' }}>
      {ready ? (
        <p>Meeting Pulse listo ✓ — presiona <strong>Guardar</strong> para añadir la pestaña.</p>
      ) : (
        <p>Iniciando…</p>
      )}
    </div>
  );
}
